<template>
    <div class="pa-5 compact-form" v-if="activeProduct">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Code" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.code"
                    @input="updateField($event, 'code')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Product name" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.name"
                    @input="updateField($event, 'name')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters v-if="activeProduct && activeProduct.data">
            <v-col class="mt-2 row-title" cols="3">{{ "Family" | t }}</v-col>
            <v-col cols="6">
                <v-select
                    :value="activeProduct.product_brand_id"
                    @input="updateField($event, 'product_brand_id')"
                    placeholder="Select"
                    :items="productBrands"
                    item-text="title"
                    item-value="id"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Status" | t }}</v-col>
            <v-col cols="6">
                <v-select
                    :value="activeProduct.status"
                    @input="updateField($event, 'status')"
                    placeholder="Select"
                    :items="statusItems"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Type" | t }}</v-col>
            <v-col cols="6">
                <v-select
                    :value="activeProduct.product_type"
                    @input="updateField($event, 'product_type')"
                    placeholder="Select"
                    :items="productTypes"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ `ODOO ${t("Code").toLowerCase()}` }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.odoo_code"
                    @input="updateField($event, 'odoo_code')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-divider class="mb-3 mt-3"></v-divider>
        <v-row no-gutters v-if="activeProduct && activeProduct.data">
            <v-col class="mt-2 row-title" cols="3">{{ "Accounting class" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.data.accounting_class"
                    @input="updateJsonField($event, 'accounting_class')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="align-center">
            <v-col class="mt-1 row-title" cols="3">{{ "Price list price" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.list_net_price"
                    @input="updateField($event, 'list_net_price')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    type="number"
                    :disabled="!allowedRoles.includes(user.role)"
                    outlined
                />
            </v-col>
            <v-col cols="1" class="pl-2" v-if="allowedRoles.includes(user.role)">
                <v-icon @click="openPriceModal('list_net_price')" small>
                    fas fa-pencil-alt
                </v-icon></v-col
            >
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Cost price" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.cost_price"
                    @input="updateField($event, 'cost_price')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    :disabled="!allowedRoles.includes(user.role)"
                    type="number"
                    outlined
                />
            </v-col>
            <v-col cols="1" class="pl-2" v-if="allowedRoles.includes(user.role)">
                <v-icon @click="openPriceModal('cost_price')" small>
                    fas fa-pencil-alt
                </v-icon></v-col
            >
        </v-row>
        <v-row no-gutters class="align-center">
            <v-col class="row-title" cols="3">{{ "Own price" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.own_price"
                    @input="updateField($event, 'own_price')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    type="number"
                    :disabled="!allowedRoles.includes(user.role)"
                    outlined
                />
            </v-col>
            <v-col cols="1" class="pl-2" v-if="allowedRoles.includes(user.role)">
                <v-icon @click="openPriceModal('own_price')" small>
                    fas fa-pencil-alt
                </v-icon></v-col
            >
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{
                `${t("E-shop price")} (${activeProduct.bags_in_box ? activeProduct.bags_in_box : "0"} ${t("bags")})`
            }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.e_shop_price"
                    @input="updateField($event, 'e_shop_price')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    type="number"
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Export price" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.export_price"
                    @input="updateField($event, 'export_price')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    type="number"
                    :disabled="!allowedRoles.includes(user.role)"
                    outlined
                />
            </v-col>
            <v-col cols="1" class="pl-2" v-if="allowedRoles.includes(user.role)">
                <v-icon @click="openPriceModal('export_price')" small>
                    fas fa-pencil-alt
                </v-icon></v-col
            >
        </v-row>
        <v-row no-gutters v-if="activeProduct && activeProduct.data">
            <v-col class="mt-2 row-title" cols="3">{{ "Market" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.data.market"
                    @input="updateJsonField($event, 'market')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters v-if="activeProduct && activeProduct.data">
            <v-col class="mt-2 row-title" cols="3">{{ "Product name (eng)" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.data.name_en"
                    @input="updateJsonField($event, 'name_en')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters v-if="activeProduct && activeProduct.data">
            <v-col class="mt-2 row-title" cols="3">{{ "Base Net price" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.data.base_net_price"
                    @input="updateJsonField($event, 'base_net_price')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    type="number"
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters v-if="activeProduct && activeProduct.data">
            <v-col class="mt-2 row-title" cols="3">{{ "Preservation conditions (min)" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.data.preservation_conditions_min"
                    @input="updateJsonField($event, 'preservation_conditions_min')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    type="number"
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters v-if="activeProduct && activeProduct.data">
            <v-col class="mt-2 row-title" cols="3">{{ "Preservation conditions (max)" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.data.preservation_conditions_max"
                    @input="updateJsonField($event, 'preservation_conditions_max')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    type="number"
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Category" | t }}</v-col>
            <v-col cols="6">
                <v-select
                    :value="activeProduct.product_category_id"
                    @input="updateField($event, 'product_category_id')"
                    placeholder="Select"
                    :items="productCategories"
                    item-text="title"
                    item-value="id"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Odoo category" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.odoo_category"
                    @input="updateField($event, 'odoo_category')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    type="text"
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Storage life (months)" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.storage_life"
                    @input="updateField($event, 'storage_life')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    @keypress="onlyIntegers"
                    type="number"
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Storage conditions" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.storage_conditions"
                    @input="updateField($event, 'storage_conditions')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Comment" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeProduct.comment"
                    @input="updateField($event, 'comment')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Launched date" | t }}</v-col>
            <v-col cols="6">
                <date-picker
                    :popover="{ placement: 'bottom', visibility: 'click' }"
                    v-model="launchedDate"
                    :value="activeProduct.launched_date"
                    @input="updateDatePickerField($event, 'launched_date')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="mt-1">
            <v-col class="mt-2 row-title" cols="3">{{ "Finished date" | t }}</v-col>
            <v-col cols="6">
                <date-picker
                    :popover="{ placement: 'bottom', visibility: 'click' }"
                    v-model="finishedDate"
                    :value="activeProduct.finished_date"
                    @input="updateDatePickerField($event, 'finished_date')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-divider class="mb-3 mt-3"></v-divider>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Unit" | t }}</v-col>
            <v-col cols="6">
                <v-select
                    :value="activeProduct.unit"
                    @input="updateField($event, 'unit')"
                    class="text-field-item mb-1"
                    :items="unitItems"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-divider class="mb-3 mt-3"></v-divider>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Image" | t }}</v-col>
            <v-col cols="6">
                <v-file-input
                    show-size
                    hide-details
                    dense
                    accept="image/*"
                    :label="activeProduct.image ? activeProduct.image : t('Upload')"
                    :value="activeProduct.image_path"
                    @change="updateImageField($event)"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";
import Store from "../../../store";

export default {
    name: "general-info-edit-tab",
    components: {
        DatePicker
    },
    data() {
        return {
            statusItems: ["active", "in development", "inactive", "special order", "private label"],
            unitItems: ["pc", "kg"],
            launchedDate: null,
            finishedDate: null,
            dateToday: new Date(),
            allowedRoles: ["superadmin"]
        };
    },
    computed: {
        ...mapState("ProductStore", ["activeProduct", "productCategories", "productBrands", "productTypes"]),
        ...mapState(["user"])
    },
    watch: {
        activeProduct: function() {
            if (this.activeProduct.launched_date)
                this.launchedDate = moment(this.activeProduct.launched_date, "YYYY-MM-DD").toDate();
            if (this.activeProduct.finished_date)
                this.finishedDate = moment(this.activeProduct.finished_date, "YYYY-MM-DD").toDate();
        }
    },
    methods: {
        ...mapMutations("ProductStore", ["changeClassificatorValue", "setPriceModal", "setPriceModalType"]),
        updateDatePickerField(value, field) {
            let new_value = moment(value).format("YYYY-MM-DD");
            Store.commit("ProductStore/updateActiveProductProperty", { prop: field, value: new_value });
        },
        updateField(value, field) {
            Store.commit("ProductStore/updateActiveProductProperty", { prop: field, value: value });
        },
        updateJsonField(value, field) {
            Store.commit("ProductStore/updateActiveProductJsonField", { prop: field, value: value });
        },
        updateImageField(e) {
            Store.commit("ProductStore/setImageFile", { value: e });
        },
        onlyIntegers($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which;

            if (keyCode < 48 || keyCode > 57 || keyCode === 46) {
                $event.preventDefault();
            }
        },
        async openPriceModal(priceType) {
            console.log("clicked");
            await this.setPriceModalType(priceType);
            await this.setPriceModal(true);
        }
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
::v-deep .v-input__slot {
    min-height: 9px !important;
}
::v-deep .v-select__slot > .v-select__selections {
    padding: 0px !important;
}
::v-deep .v-input__icon {
    padding-bottom: 8px;
}
</style>
